import React from 'react';
import StackNavigator from '../app-components/stack/StackNavigator';
import { registerAction } from '../app-components/action/Action';
import {
  invokeAction,
  formUpdateInvokeAction,
} from '../app-components/action/InvokeAction';
import { downloadAction } from '../app-components/action/DownloadAction';
import { GroupFilterAction } from '../app-components/action/FilterAction';
import LinkAction from '../app-components/action/LinkAction';
import ModalLinkAction from '../app-components/action/ModalLinkAction';
import { closeAction } from '../app-components/action/CloseAction';
import ConfirmAction from '../app-components/action/ConfirmAction';
import { saveAction } from '../app-components/action/SaveAction';
import AuthScreens from '../Auth';
import { ScreenComponent } from '../app-components/screen/ScreenComponent';
import ConfirmView from '../app-components/screen/ConfirmView';
import AppContainer from './AppContainer';
import Screens from '../screens';
import { ROUTES } from '../Lib/constants';
import Home from '../Home';
import TNC from '../t-n-c';
import HTW from '../h-i-w/index';
import Unsubscribe from '../Unsubscribe';
import CustomerInterest from '../CustomerInterest';

// import Captured from '../Captured';
import { ViewAppraisalResult } from '../screens/AppraisalResult/View';

/*
  *************
  Following functions are used to register the actions that can be fired by action types
  in applane components
  *************
*/

registerAction('invoke', invokeAction);
registerAction('link', LinkAction);
registerAction('modalLink', ModalLinkAction);
registerAction('close', closeAction);
registerAction('save', saveAction);
registerAction('confirm', ConfirmAction);
registerAction('download', downloadAction);
registerAction('formUpdateInvoke', formUpdateInvokeAction);
registerAction('groupFilter', GroupFilterAction);

let { pathname } = typeof window !== undefined ? window.location : { pathname: '/' };
const pathSegments = pathname.split('/');
const token = pathSegments[pathSegments.length - 1];

const AppNavigator = StackNavigator(


  {
    authenticator: { screen: AuthScreens.Authenticator },

    payment: {
      screen: ({ navigation }) => (
        <AuthScreens.payment navigation={navigation} />
      ),
    },

    contactUs: {
      public: true,
      screen: ({ navigation }) => (
        <AuthScreens.ContactUs navigation={navigation} />
      ),
    },

    [`unsubscribe/${token}`]: { 
      public: true,
      screen: ({ navigation }) => (
        <Unsubscribe navigation={navigation} />
      ),
    },  
    [`customer-interest/${token}`]: { 
      public: true,
      screen: ({ navigation }) => (
        <CustomerInterest navigation={navigation} />
      ),
    },  
    // uci: {
    //   screen: ({ navigation }) => (
    //     <Captured navigation={navigation}/>
    //   ),
    // },

    signup: {
      public: true,
      screen: ({ navigation }) => (
        <AuthScreens.Signup navigation={navigation} />
      ),
    },

    termsAndConditions: {
      screen: ({ navigation }) => <TNC navigation={navigation} />,
    },
    howitworks: { screen: ({ navigation }) => <HTW navigation={navigation} /> },

    // landing: {
    //   screen: ({ navigation }) => <Home navigation={navigation} />,
    // },

    login: {
      public: true,
      screen: ({ navigation }) => <AuthScreens.Login navigation={navigation} />,
    },
    'view-appraisal-result': {
      screen: ({ navigation }) => <ViewAppraisalResult navigation={navigation} />,
    },
    [ROUTES.ResetPassword.name]: {
      screen: ({ navigation }) => (
        <AuthScreens.ResetPassword navigation={navigation} />
      ),
    },

    [ROUTES.ForgotPassword.name]: {
      expanded: true,
      screen: ({ navigation }) => (
        <AuthScreens.ForgotPassword navigation={navigation} />
      ),
    },

    [ROUTES.ChangePassword.name]: {
      screen: ({ navigation }) => (
        <AuthScreens.ChangePassword navigation={navigation} />
      ),
    },

    ...Screens,
    confirm: { screen: ConfirmView },
  },

  {
    Container: AppContainer,
    ScreenComponent,
    navigationKey: 'main',
  },
);

export default AppNavigator;
